import { Box, Button, FormControl, FormLabel, Input } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';

export function Form({ isLoading }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    defaultValues: {
      cliente: searchParams.get('query') || ''
    }
  });

  const onSubmit = async (values) => {
    setSearchParams({ query: values.cliente });
    console.log(values);
  };

  return (
    <Box
      as="form"
      maxWidth="450px"
      mx="auto"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      alignItems="flex-end"
      mb={5}
      gap={4}>
      <FormControl isInvalid={errors.cliente}>
        <FormLabel htmlFor="cliente" color="gray.500" fontSize="sm" fontWeight="bold">
          {' '}
          CPF/CNPJ, CodParc, Nome / Razão Social
        </FormLabel>
        <Input
          id="cliente"
          placeholder="cliente"
          {...register('cliente', {
            required: 'Campo obrigatório',
            minLength: {
              value: 3,
              message: 'Mínimo de 3 caracteres'
            }
          })}
        />
      </FormControl>
      <Button colorScheme="blue" isLoading={isLoading} loadingText="Buscando..." type="submit">
        Buscar
      </Button>
    </Box>
  );
}
